import { i18n } from '../translate/i18n';
import moment from 'moment';

const statusLabel = (id, deadline = '') => {
  switch (id) {
    case 'progress':
      if(new Date() < moment(new Date(deadline)).endOf('day').toDate() || deadline === '') {
        return {
          title: i18n.t('statusLabel.title'),
          color: '#ffd700'
        }
      } 
			return {
				title: i18n.t('statusLabel.title1'),
				color: 'red'
			}
      
    case 'canceled':
      return {
        title: i18n.t('statusLabel.title2'),
        color: 'black'
      }
    case 'completed':
      return {
        title: i18n.t('statusLabel.title3'),
        color: 'green'
      }
    default: return {
      title: i18n.t('statusLabel.title3'),
      color: 'green'
    }
  }
}

export default statusLabel;
